var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatePresence, motion } from "framer";
import { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { CheckIcon } from "../../assets/icons/icons";
import { BaseButton, Title } from "../../designSystem";
import colors from "../../designSystem/colors";
import sizes from "../../designSystem/sizes";
import theme from "../../designSystem/theme";
import { useBoundingclientrect } from "../../hooks/useBoundingclientrect";
import useOutsideAlerter from "../../hooks/useOutsideAlerter";
import useScreenSize from "../../hooks/useScreenSize";
import ButtonArrow from "./ButtonArrow";
var Filter = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 46%;\n"], ["\n  position: relative;\n  width: 46%;\n"])));
var FilterButton = styled(BaseButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  height: 56px;\n  line-height: 56px;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 0;\n  margin-right: 40px;\n  padding: ", ";\n  ", "\n"], ["\n  display: flex;\n  width: 100%;\n  height: 56px;\n  line-height: 56px;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 0;\n  margin-right: 40px;\n  padding: ", ";\n  ", "\n"])), function (props) {
    return props.config.paddingVertical + "px " + props.config.paddingHorizontal + "px";
}, function (props) {
    return props.active
        ? "\n          border: 1px solid rgba(226,248,241, 1);\n        "
        : "\n          border: 1px solid rgba(226,248,241, 0.5);\n        ";
});
var FilterButtonText = styled(Title)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: 1;\n  color: ", ";\n  text-transform: capitalize;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  span {\n    text-transform: capitalize;\n  }\n"], ["\n  flex: 1;\n  color: ", ";\n  text-transform: capitalize;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  span {\n    text-transform: capitalize;\n  }\n"])), function (props) { return props.config.color; });
var FilterDropdownMenu = styled(motion.div)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    return props.isOpen
        ? "\n          position: absolute;\n          z-index: 2000;\n          border: 1px solid rgba(226,248,241, 0.5);\n          " + (function () {
            switch (props.config.horizontalOrientation) {
                case "left":
                    return "left: 0px;";
                case "right":
                default:
                    return "right: 0px;";
            }
        })() + "\n          " + (function () {
            switch (props.verticalOrientation) {
                case "top":
                    return "bottom: 48px;";
                case "bottom":
                default:
                    return "top: calc(21px + " + props.buttonPaddingVertical * 2 + "px + " + props.config.topBuffer + "px);";
            }
        })() + "\n          width: fit-content;\n          background-color: #043F3D;\n\n        "
        : "\n          display: none;\n        ";
});
var MenuItemsContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    return props.horizontal &&
        "\n      display: flex;\n      width: 440px;\n      flex-wrap: wrap;\n      margin-left: -16px;\n";
});
var MenuItem = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 200px;\n  height: 50px;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 8px 40px 8px 16px;\n  &:hover {\n    span {\n      color: ", ";\n    }\n    background-color: #0A3836;\n  }\n"], ["\n  width: 200px;\n  height: 50px;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 8px 40px 8px 16px;\n  &:hover {\n    span {\n      color: ", ";\n    }\n    background-color: #0A3836;\n  }\n"])), colors.primaryText);
var LogoContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  margin: -12px;\n  margin-right: 8px;\n  border-radius: 100px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  margin: -12px;\n  margin-right: 8px;\n  border-radius: 100px;\n"])), function (props) { return (props.mode === "compact" ? "24px" : "40px"); }, function (props) { return (props.mode === "compact" ? "24px" : "40px"); });
var MenuItemText = styled(Title)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  white-space: nowrap;\n  font-size: 14px;\n  line-height: 20px;\n  transition: color 150ms;\n  text-transform: capitalize;\n"], ["\n  white-space: nowrap;\n  font-size: 14px;\n  line-height: 20px;\n  transition: color 150ms;\n  text-transform: capitalize;\n"])));
var StyledCheckButton = styled(CheckIcon)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  path {\n    transition: fill 150ms;\n    stroke: ", ";\n  }\n"], ["\n  path {\n    transition: fill 150ms;\n    stroke: ", ";\n  }\n"])), function (props) { return props.color; });
var SaveButton = styled(BaseButton)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  padding: 12px 24px;\n  margin-top: 24px;\n  background: ", "14;\n  border-radius: ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  padding: 12px 24px;\n  margin-top: 24px;\n  background: ", "14;\n  border-radius: ", ";\n"])), colors.primaryText, theme.border.radius);
var MultiselectFilterDropdownAsset = function (_a) {
    var values = _a.values, options = _a.options, title = _a.title, onSelect = _a.onSelect, _b = _a.mode, mode = _b === void 0 ? "default" : _b, _c = _a.buttonConfig, buttonConfig = _c === void 0 ? {
        // background: colors.background.two,
        // activeBackground: colors.background.three,
        border: "1px solid #E2F8F1",
        paddingHorizontal: 16,
        paddingVertical: 16,
        color: "" + colors.primaryText,
    } : _c, _d = _a.dropdownMenuConfig, dropdownMenuConfig = _d === void 0 ? {
        horizontalOrientation: "left",
        topBuffer: 16,
    } : _d, props = __rest(_a, ["values", "options", "title", "onSelect", "mode", "buttonConfig", "dropdownMenuConfig"]);
    var ref = useRef(null);
    var _e = useState(false), open = _e[0], setOpen = _e[1];
    var _f = useScreenSize(), height = _f.height, width = _f.width;
    var dropdownBoundingRect = useBoundingclientrect(ref);
    var _g = useState(values), selected = _g[0], setSelected = _g[1];
    // Reset selected value if close without save
    useEffect(function () {
        if (!open) {
            setSelected(values);
        }
    }, [open, values]);
    useOutsideAlerter(ref, function () {
        setOpen(false);
    });
    var renderMenuItem = useCallback(function (option) {
        var active = selected.includes(option.value);
        var textColor = option.textColor ? option.textColor : option.color;
        return (_jsx(MenuItem, __assign({ mode: mode, onClick: function () {
                // setSelected((currSelected) =>
                //   currSelected.includes(option.value)
                //     ? currSelected.filter((curr) => curr !== option.value)
                //     : currSelected.concat(option.value)
                // );
                if (option.value === 'All Strategies') {
                    onSelect([]);
                }
                else {
                    onSelect([option.value]);
                }
                setOpen(false);
            }, role: "button", color: option.color, active: active }, { children: _jsx(MenuItemText, { children: option.display }, void 0) }), option.value));
    }, [selected, mode]);
    var getVerticalOrientation = useCallback(function () {
        /**
         * Height of dropdown: 48px
         * Height of each option: 36px
         * Total dropdown margin: 16px
         */
        if (dropdownBoundingRect &&
            dropdownBoundingRect.top +
                48 +
                options.length * 36 +
                16 +
                (width > sizes.lg
                    ? theme.footer.desktop.height
                    : theme.footer.mobile.height) >
                height) {
            return "top";
        }
        return "bottom";
    }, [width, height, dropdownBoundingRect, options]);
    return (_jsxs(Filter, __assign({}, props, { ref: ref }, { children: [_jsx(FilterButton, __assign({ role: "button", active: open, onClick: function () {
                    setOpen(function (open) { return !open; });
                }, config: buttonConfig }, { children: _jsxs(FilterButtonText, __assign({ config: buttonConfig }, { children: [_jsx("span", { children: values.length > 0 ? values[0] : "All Strategies" }, void 0), _jsx(ButtonArrow, { style: { float: 'right' }, isOpen: open }, void 0)] }), void 0) }), void 0), _jsx(AnimatePresence, { children: _jsx(FilterDropdownMenu, __assign({ isOpen: open, verticalOrientation: getVerticalOrientation(), buttonPaddingVertical: buttonConfig.paddingVertical, config: dropdownMenuConfig, initial: {
                        opacity: 0,
                        y: 20,
                    }, animate: {
                        opacity: 1,
                        y: 0,
                    }, exit: {
                        opacity: 0,
                        y: 20,
                    }, transition: {
                        type: "keyframes",
                        duration: 0.2,
                    } }, { children: _jsx(MenuItemsContainer, __assign({ horizontal: mode === "compact" }, { children: options.map(function (filterOption) { return renderMenuItem(filterOption); }) }), void 0) }), open.toString()) }, void 0)] }), void 0));
};
export default MultiselectFilterDropdownAsset;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=MultiselectFilterDropdownAsset.js.map